<i18n>
{
	"en": {
		"hasNoReferences": "No system references found"
	},
	"no": {
		"hasNoReferences": "Fant ingen systemreferanser"
	}
}
</i18n>

<template>
	<div class="system-references">

		<MultipleTextAreas
			:textAreas="textAreas"
			:noContentString="$t('hasNoReferences')"
			disabled
		/>

	</div>
</template>

<script>
import {
	mapState,
} from '../store/newOrder.store';
import MultipleTextAreas from '@/modules/newOrder/common/MultipleTextAreas';
import {
	mapActions as mapActionsReferences, mapGetters as mapGettersReferences,
	mapState as mapStateReferences
} from '@/modules/references/store/references.store';
import { i18n } from '@/core';

export default {
	name: 'SystemReferences',
	components: { MultipleTextAreas },
	data() {
		return {
			currentTabKey: null,
		};
	},
	computed: {

		...mapState(['order']),
		...mapStateReferences(['references']),
		...mapGettersReferences(['referenceCodeToReferenceMap']),

		systemReferences() {

			return this.order.additionalReferences.reduce(
				(systemReferences, reference) => {

					let referenceData = this.referenceCodeToReferenceMap.get( reference.code );


					if (referenceData && referenceData.isSystemReference)
						systemReferences.push(reference);

					return systemReferences;

				},
				[]
			);
		},

		textAreas() {
			return this.systemReferences.map(
				reference => ({
					key: reference.code,

					value: reference.value,

					name: this.getTextAreaName( this.referenceCodeToReferenceMap.get( reference.code ) )
				})
			);
		}
	},
	created() {
		this.getReferences();
	},
	methods: {
		...mapActionsReferences(['getReferences']),

		getTextAreaName(referenceData) {

			if (i18n.locale === 'no' && referenceData.shortDescription && referenceData.shortDescription.no)
				return `${referenceData.shortDescription.no} (${referenceData.code})`;

			else if (i18n.locale === 'en' && referenceData.shortDescription && referenceData.shortDescription.en)
				return `${referenceData.shortDescription.en} (${referenceData.code})`;

			else return referenceData.code;
		}
	}
};
</script>

<style lang="scss" scoped>

.system-references {
	height: 100%;
	width: 100%;
	min-height: inherit;
}

</style>
